import React from "react";

import * as styles from "./Button.module.css";

const Button = ({ label, onClick = () => {}, type, disabled, name }) => (
  <button type={type} name={name} onClick={onClick} disabled={disabled} className={styles.button}>
    {label}
  </button>
);

export default Button;
